import Nav from './components/Nav';
import Hero from './components/Hero';
import Business from './components/Business';
import Federation from './components/Federation';
import Growth from './components/Growth';
import Leadership from './components/Leadership';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Nav />
      <Hero />
      <Business gray />
      <Federation />
      <Growth gray />
      <Leadership />
      <Contact gray />
      <Footer />
    </>
  );
}
